import React from 'react';
import { Icon } from '@/app/common/icons/Icon';

const MagnifyingGlass = ({ size }: { size: number }) => (
  <Icon category="UI Essentials" name="icon-magnifying-glass" size={size} color="iconSecondary" alt="" />
);

export default MagnifyingGlass;
